export default "__VITE_ASSET__DOO9EIsG__"